import moment from 'moment';

import {
  getOperatorLeadInsuranceData,
  setMessageVisibility,
} from 'app/services/businessFunctionHelpers';
import { FormsEnum, MessagesEnum } from 'app/shared/enums';

const DATE_FORMAT = 'YYYY-MM-DD';

export const operatorLead = {
  onOperatorLeadInsuranceStartDateChange() {
    const { startDate } = getOperatorLeadInsuranceData();
    const insuranceStartDate = moment(startDate, DATE_FORMAT);
    const currentDate = moment().startOf('day');
    const isPastDate = insuranceStartDate.isBefore(currentDate, 'day');

    setMessageVisibility({
      key: MessagesEnum.InsurancePastDateNotAllowed,
      visible: isPastDate,
      formName: FormsEnum.OperatorLeadsForm,
    });
  },
};
